import React, { FunctionComponent } from 'react';

import Dinero from 'dinero.js';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import { Translate } from 'react-localize-redux';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { CircleRightArrowIcon } from '@components/basics/icons/circle-right-arrow';

interface EarningItem {
  label: React.ReactNode;
  value: Dinero.Dinero;
}

interface EarningListItemProps {
  className?: string;
  id: string;
  reportDate: string;
  title: React.ReactNode;
  titleHelper?: React.ReactNode;
  totalEarnings?: Dinero.Dinero;
  items?: EarningItem[];
  isComingSoon?: boolean;
  isSimplified?: boolean;
  plan: string;
  hasDeduction?: boolean;
}

const EarningListItem: FunctionComponent<EarningListItemProps> = ({
  className,
  id,
  reportDate,
  title,
  totalEarnings,
  isComingSoon,
}) => {
  const dispatch = useDispatch();

  const handleClick = (value: string) => {
    dispatch(push(`/earnings/${value}/${reportDate}`));
  };

  return id ? (
    <div className={className || ''}>
      <ListHeader justifyContent="space-between">
        <Flex justifyContent="flex-start" alignItems="center" gap={5}>
          <Typography customFont="semi-bold">{title}</Typography>
        </Flex>
        <Flex
          gap={10}
          flexDirection="column"
          alignItems="flex-end"
          style={{
            marginLeft: 'auto',
            alignContent: 'flex-end',
            marginRight: '10px',
          }}
        >
          <Typography customFont="semi-bold">
            {totalEarnings ? totalEarnings.toFormat() : '$0.00'}
          </Typography>
          <Typography color="gray" type="small" customFont="semi-bold">
            <Translate id="EARNINGS.LIST.LINK" />
          </Typography>
        </Flex>

        <div style={{ float: 'right', marginTop: '4px' }}>
          {!isComingSoon ? (
            <CircleRightArrowIcon
              className="icon"
              darkerCircleColor={true}
              onClick={() => handleClick(id)}
            />
          ) : (
            <div style={{ marginLeft: '27px' }}></div>
          )}
        </div>
      </ListHeader>
      <Separator />
    </div>
  ) : null;
};

export default EarningListItem;

const ListHeader = styled(Flex)`
  margin-bottom: 0px;
`;

const Separator = styled.span`
  padding-top: 40px;
  height: auto;
  width: 100%;
  display: flex;
  border-bottom: 1px dashed ${({ theme }) => theme.colors.border};
`;
